import { render, staticRenderFns } from "./SupplierDetailView.vue?vue&type=template&id=8b2c1928&"
import script from "./SupplierDetailView.vue?vue&type=script&lang=js&"
export * from "./SupplierDetailView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports